import React, { useState } from "react";

const ContactSection = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", message: "", phone: "" });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setStatus("sending");

  try {
    const response = await fetch("/api/sendMail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
      }),
    });

    const result = await response.json();

    if (result.success) {
      setStatus("success");
      setFormData({ name: "", email: "", phone: "", message: "" });
    } else {
      setStatus("error");
    }
  } catch (error) {
    console.error("Fehler beim Senden:", error);
    setStatus("error");
  }
};


  return (
    <section className="contact-section" id="contact">
      <div>
        <h2 className="contact-title">
        <span className="contact-highlight">Kontakt</span> aufnehmen und durchstarten
      </h2>
      <p className="contact-subtitle">
        Lassen Sie uns gemeinsam herausfinden, wie wir Ihre Herausforderung in ein erfolgreiches Projekt verwandeln können – persönlich, schnell und unkompliziert.
         <br/>Egal ob Unternehmen oder Talent – wir sind Ihr Ansprechpartner.
      </p>
      </div>
      <div className={`contact-grid ${!showForm ? "centered" : ""}`}>
        <div className="contact-left-wrapper">
          <div className="contact-left">
            <h2 className="contact-heading">Bereit loszulegen?</h2>
            <p className="contact-text">
              Sie planen ein neues Projekt oder benötigen frischen Input von außen? Dann schreiben Sie uns – bei Qlance ist Ihre Anfrage nur eine Nachricht entfernt.
            </p>
            <button className="contact-toggle-button" onClick={() => setShowForm(true)}>
              Zur Projektanfrage →
            </button>
          </div>
        </div>

        <div className={`contact-right ${showForm ? "visible" : "hidden"}`}>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Firma/Ansprechpartner</label>
              <input name="name" value={formData.name} onChange={handleChange} required />
            </div>
          <div className="form-group">
              <label htmlFor="email">E-Mail Adresse</label>
              <input name="email" type="email" value={formData.email} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Telefonnummer</label>
              <input
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Optional"
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Wie können wir ihnen weiterhelfen?</label>
              <textarea name="message" rows="5" value={formData.message} onChange={handleChange} required />
            </div>
            <button type="submit" className="contact-button" disabled={status === "sending"}>
              {status === "sending" ? "Senden..." : "Absenden"}
            </button>
            {status === "success" && <p className="success-message">✅ Nachricht erfolgreich gesendet!</p>}
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
